import * as React from "react";
function SvgShimmer(props, svgRef) {
  return <svg xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><defs><linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style={{
          stopColor: "#3d3d3d",
          stopOpacity: 1
        }}><animate attributeName="offset" values="0;0;0" dur="2s" repeatCount="indefinite" /></stop><stop style={{
          stopColor: "#8c8c8c",
          stopOpacity: 1
        }}><animate attributeName="offset" values="0;0;1" dur="2s" repeatCount="indefinite" /></stop><stop offset="0%" style={{
          stopColor: "#3d3d3d",
          stopOpacity: 1
        }}><animate attributeName="offset" values="0;1;2" dur="2s" repeatCount="indefinite" /></stop><stop style={{
          stopColor: "#8c8c8c",
          stopOpacity: 1
        }}><animate attributeName="offset" values="1;2;3" dur="2s" repeatCount="indefinite" /></stop></linearGradient></defs><rect width="100%" height="100%" fill="url(#grad1)" /></svg>;
}
const ForwardRef = React.forwardRef(SvgShimmer);
export default __webpack_public_path__ + "src/openspace/assets/svg/shimmer.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/openspace/assets/svg/shimmer_0.5x.svg",
  "1x": __webpack_public_path__ + "src/openspace/assets/svg/shimmer_1x.svg",
  "2x": __webpack_public_path__ + "src/openspace/assets/svg/shimmer_2x.svg",
  "3x": __webpack_public_path__ + "src/openspace/assets/svg/shimmer_3x.svg",
  "4x": __webpack_public_path__ + "src/openspace/assets/svg/shimmer_4x.svg"
};
export { ForwardRef as ReactComponent };